import React, { useState } from "react";
import { Row, Col } from "antd";
import {
  InputLayout,
  FlexContainerHelper,
} from "../../../components/dashboard-layout/styledComponents";
import Button from "../../../components/dashboard-layout/button/Button";
import DashboardModal from "../../../components/dashboard-layout/modal/DashboardModal";
import useInput from "../../../hooks/useInput";
import { inviteDriver } from "../../../Services/firebase";
import Spinner from "../../../components/dashboard-SA/Spinner";
import { ErrorMessage } from "../../../components/auth-layout/styledComponents";
import { toast } from "react-toastify";
import { Select } from "antd";
import { SelectLayout } from "../../../components/dashboard-layout/styledComponents";
import styled from "styled-components";
import { useEffect } from "react";

const { Option } = Select;

const emailRgx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const phoneRgx = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
function TransporterForm({ modalSetting, updateDrivers }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const email = useInput("", isSubmitting);
  const name = useInput("", isSubmitting);
  const phone = useInput("", isSubmitting);
  const lastName = useInput("", isSubmitting);
  const [driverType, setDriverType] = useState("OWN");

  const cleanForm = () => {
    email.setValue("");
    email.setError("");
    name.setValue("");
    name.setError("");
    lastName.setValue("");
    lastName.setError("");
    phone.setValue("");
    phone.setError("");
  };

  useEffect(() => {
    if (modalSetting.visible) {
      cleanForm();
    }
  }, [modalSetting.visible]);

  const onInviteDriver = async () => {
    setIsSubmitting(true);
    if (!name.value || !lastName.value || !driverType) {
      return;
    }

    if (driverType === "OWN" && !phone.value) {
      return;
    }
    if (driverType === "OWN" && !phoneRgx.test(phone.value)) {
      phone.setError("Por favor, Ingresa un teléfono válido");
      return;
    }

    if (driverType === "OUTSOURCED" && !email.value) {
      return;
    }

    if (driverType === "OUTSOURCED" && !emailRgx.test(email.value)) {
      email.setError("Por favor, Ingresa un Correo electrónico válido");
      return;
    }

    try {
      setLoading(true);
      const { data } = await inviteDriver(
        `${name.value} ${lastName.value}`,
        email.value,
        driverType,
        phone.value
      );
      updateDrivers(data);
      toast.success(`Se ha enviado una invitacion a ${email.value}`);
      cleanForm();
      modalSetting.handleCancel();
      setLoading(false);
    } catch (error) {
      setLoading(false);

      if (error.message.includes("already invited")) {
        toast.error("Este conductor ya tiene una invitación");
        return;
      }
      if (error.message.includes("already exists")) {
        toast.error("Este conductor ya existe");
        return;
      }
      if (error.message.includes("belongs to another organization")) {
        toast.error("Este conductor pertenece a otra organización");
        return;
      }

      toast.error(error?.message || "Error inesperado");
      return;
    }
  };
  const onChangeDriverType = (value) => setDriverType(value);
  return (
    <DashboardModal
      {...modalSetting}
      handleCancel={() => {
        modalSetting.handleCancel();
        cleanForm();
      }}
      footer={null}
    >
      <p>
        Para agregar un conductor ingresa el correo electrónico, se le enviara
        una invitación para que acceda a la aplicación.
      </p>
      <Row gutter={6}>
        <Col span={12}>
          <label>Nombre</label>
          <InputLayout
            type="text"
            placeholder="Ingresar nombre"
            size="large"
            value={name.value}
            onChange={(e) => {
              name.onChange(e);
            }}
          />
          <ErrorMessage error={!!name.error}>{name.error}</ErrorMessage>
        </Col>
        <Col span={12}>
          <label>Apellido</label>
          <InputLayout
            type="text"
            placeholder="Ingresar nombre"
            size="large"
            value={lastName.value}
            onChange={(e) => {
              lastName.onChange(e);
            }}
          />
          <ErrorMessage error={!!lastName.error}>{lastName.error}</ErrorMessage>
        </Col>
      </Row>
      <Row>
        <label>Correo Electrónico del conductor</label>
        <InputLayout
          type="email"
          placeholder="Ingresar correo electrónico"
          size="large"
          value={email.value}
          onChange={(e) => {
            email.onChange(e);
          }}
        />
        <ErrorMessage error={!!email.error}>{email.error}</ErrorMessage>
      </Row>
      {driverType === "OWN" && (
        <Row>
          <label>Teléfono del conductor</label>
          <InputLayout
            type="text"
            placeholder="Ingresar teléfono"
            size="large"
            value={phone.value}
            onChange={(e) => {
              phone.onChange(e);
            }}
          />
          <ErrorMessage error={!!phone.error}>{phone.error}</ErrorMessage>
        </Row>
      )}
      <Row gutter={6} style={{ marginBottom: "50px", marginTop: 20 }}>
        <Col span={12}>
          <label>Tipo de conductor:</label>
          <SelectLayout onChange={onChangeDriverType} value={driverType}>
            <Option value="OWN">Propio</Option>
            <Option value="OUTSOURCED">Tercero</Option>
          </SelectLayout>
        </Col>
      </Row>
      <div>
        <FlexContainerHelper justify="flex-end">
          <Button
            type="alternative"
            actionButton={() => {
              cleanForm();
              modalSetting.handleCancel();
            }}
          >
            Cancel
          </Button>
          <Button type="primary" actionButton={onInviteDriver}>
            {loading ? <Spinner color="#ffF" /> : "Enviar invitación"}
          </Button>
        </FlexContainerHelper>
      </div>
    </DashboardModal>
  );
}

export default TransporterForm;
